<template>
  <div v-if="show" class="sidebar-links">
    <router-link :to="{name: 'PersonalInfo'}" exact>General settings</router-link>
<!-- CHECK USER HOSPITALS PERMS -->
    <!-- <rp-permissions :requireAll="['read_user_hospitals', 'write_user_hospitals']">
      <router-link to="/settings/surgeon_hospitals" exact-clas="active" :class="{active: isActiveMyHospitals}">My Hospitals</router-link>
    </rp-permissions> -->

    <div v-if="isSurgeon">
      <router-link to="/settings/enter_registration_key">Register RayPRO</router-link>
      <router-link to="/settings/questionnaire_preferences">Questionnaire Preferences</router-link>
      <rp-permissions :requireOne="['read_phin_report']">
        <router-link :to="{name: 'PhinExport'}">Export PHIN Report</router-link>
      </rp-permissions>
    </div>
    <div v-if="isAdmin">
      <router-link to="/settings/manage_registration_keys">Generate Product Keys</router-link>
    </div>

    <rp-permissions :requireOne="['associate_nurse']">
      <router-link to="/settings/associate_nurse">Associate Nurse</router-link>
    </rp-permissions>
    <rp-permissions :requireOne="['associate_hospitals']">
      <router-link to="/settings/associate_hospital">Associate Hospital</router-link>
    </rp-permissions>
    <rp-permissions :requireOne="['generate_access_code']">
      <router-link to="/settings/generate_access_code">Generate Access Code</router-link>
    </rp-permissions>
    <rp-permissions :requireAll="['manage_languages', 'read_translations', 'write_translations', 'read_translation_entrys', 'write_translation_entrys', ]">
      <router-link :to="{name: 'ManageLanguages'}">Manage Languages</router-link>
    </rp-permissions>
    <rp-permissions :requireAll="['write_iols']">
      <router-link :to="{name: 'ManageIols'}">Manage IOLs</router-link>
    </rp-permissions>
    <rp-permissions :requireAll="['write_system_notifications']">
      <router-link :to="{name: 'ManageNotifications'}">Manage Notifications</router-link>
    </rp-permissions>
    <rp-permissions :requireOne="['admin_read_phin_report']">
      <router-link :to="{name: 'PhinExport'}">Export PHIN Report</router-link>
    </rp-permissions>
    <rp-permissions :requireOne="['admin_import_operations_csv']">
      <router-link to="/settings/admin_operation_upload">Upload Operations</router-link>
    </rp-permissions>
    <router-link :to="{name: 'ResetPassword'}" exact>Reset Password</router-link>
    <router-link :to="{name: 'DeleteAccount'}" exact>Delete Account</router-link>
    <a href="#" @click="logout">Logout</a>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

import Permissions from 'raypro_ui/src/components/Permissions'

export default {
  components: {'rp-permissions': Permissions},
  computed: {
    ...mapGetters(['getAuthToken', 'isAdmin', 'isSurgeon']),

    path() {
      return this.$route.path
    },

    show() {
      return new RegExp('/settings').test(this.path)
    }
  },
  methods: {
    ...mapActions([
      'logoutUser'
    ]),

    logout() {
      this.logoutUser(this.getAuthToken)
        .then(() => {
          this.$root.$emit('logout')
          this.$router.push({name: 'Login'})
        })
        .catch(({response}) => {
          this.errors = response
        })
    }
  }
}
</script>

<style lang="sass">
</style>



// WEBPACK FOOTER //
// src/components/SideNav/SettingsLinks.vue